import React from 'react';
import PropTypes from 'prop-types';
import {
  getAddressValidation,
  ContactInfoForm,
  getContactInfoValidation,
  GridContainer,
  NameForm,
  getNameValidation,
} from '../../common';

import ContactRoleField, { getRoleValidation } from './ContactRoleField';

function ContactForm({ paths, setFieldValue, values }) {
  return (
    <GridContainer>
      <NameForm lastNameRequired paths={paths} />
      <ContactInfoForm
        emailRequired={false}
        paths={paths}
        setFieldValue={setFieldValue}
        values={values}
      />
      <ContactRoleField paths={paths} />
    </GridContainer>
  );
}

ContactForm.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  paths: PropTypes.array,
};

ContactForm.defaultProps = {
  paths: [],
};

export default ContactForm;

export const contactValidationSchema = {
  ...getAddressValidation({ required: false }),
  ...getContactInfoValidation({ emailRequired: false, phoneRequired: false }),
  ...getNameValidation({ firstNameRequired: false, lastNameRequired: true }),
  ...getRoleValidation({ required: false }),
};



// WEBPACK FOOTER //
// ./src/modules/PrimaryDoctorPage/components/ContactForm.js